import React from "react";

import styled from "styled-components/macro";

import { CELL_MIN_WIDTH_IN_PX, useCellMeasurements } from "Boards";

export function Cell({ children, rowIndex, columnID, columnType, ...props }) {
  const { width } = useCellMeasurements({ columnID, columnType });

  const style = {
    width: `${typeof width === "number" ? width : CELL_MIN_WIDTH_IN_PX}px`,
  };

  return (
    <Wrapper style={style} {...props}>
      {children}
    </Wrapper>
  );
}

const maxWidth = "300px";

export const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 0 6px;
  height: 40px;
  min-width: 150px;
  max-width: ${maxWidth};
  flex-grow: 0;
  flex-shrink: 0;
  border-bottom: 1px solid #eceff0;
  display: flex;
  line-height: 16px;
  align-items: center;
  position: relative;
  z-index: 1;

  & > div {
    flex-grow: 1;
  }

  // brittle way to ensure cells with inputs are properly scrolled into view
  //   and not "hidden" under the sticky Name cell
  &:not(:first-child) {
    button,
    input,
    [role="checkbox"] {
      scroll-margin-left: ${maxWidth};
    }
  }
`;
